import { action } from 'easy-peasy';
import { newsArticles } from '../static/news/newsArticles.js';

const newsModel = {
    news: [],

    fetchNews: action((state) => {
        state.news = newsArticles;
    }),

}

export default newsModel;
